<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="info.fieldTag"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type == 'ages'">
              <info-ages
                :ages="infoData.ages"
                :changeLabel="infoData.changeLabel"
              />
            </template>
            <template
              v-else-if="info.type == 'bw_config' && infoData.canConfigBW"
            >
              <info-bw :leafs="infoData.leafs" />
            </template>
            <template v-else-if="info.type === null"></template>
            <td v-else>
              <h6>
                <strong>{{ info.label }}</strong>
              </h6>
              <p class="mt-1">{{ info.value }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';
import BiologicalWarningInfo from 'src/views/Pages/Dashboard/Sigatoka/Config/steps/BiologicalWarningInfo.vue';
import AgesInfo from 'src/views/Pages/Dashboard/Sigatoka/Config/steps/AgesInfo.vue';

export default {
  name: 'step-confirm',
  components: {
    [BiologicalWarningInfo.name]: BiologicalWarningInfo,
    [AgesInfo.name]: AgesInfo,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.companies2'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('sigatoka.ages_to_evaluate'),
          value: (this.infoData.ages || []).map((age) => this.mapAge(age)),
          type: 'ages',
        },
        {
          label: i18n.t('sigatoka.evaluate_young_plants') + '?',
          value: this.infoData.hasYoungPlants
            ? i18n.t('common_words.yes')
            : i18n.t('common_words.no'),
        },
        {
          label: i18n.t('sigatoka.can_config_bw') + '?',
          value: this.infoData.canConfigBW
            ? i18n.t('common_words.yes')
            : i18n.t('common_words.no'),
        },
        {
          label: i18n.t('sigatoka.change_label') + '?',
          value: this.infoData.changeLabel
            ? i18n.t('common_words.yes')
            : i18n.t('common_words.no'),
        },
        {
          label: this.infoData.hasYoungPlants
            ? i18n.t('sigatoka.number_leaves_to_evaluate')
            : null,
          value: this.infoData.hasYoungPlants
            ? this.infoData.young_leaves.filter((v) => v !== null).join(', ')
            : null,
        },
        {
          label: this.infoData.canConfigBW
            ? i18n.t('sigatoka.can_config_bw')
            : null,
          value: this.infoData.canConfigBW ? this.infoData.leafs : null,
          type: this.infoData.canConfigBW ? 'bw_config' : null,
        },
      ];
    },
  },
  methods: {
    mapAge(age) {
      if (age === 0) return i18n.t('sigatoka.expecting');
      if (age === 1) return i18n.t('sigatoka.newly_given_birth');
      return `${age} ${i18n.t('common_words.weeks')}`;
    },
  },
};
</script>
